import { useState } from "react";
import { Button, Form, Col, Container, Modal, Row } from "react-bootstrap";
import "../../assets/styles/scheduledChanges.scss";

const ScheduledChangesFilters = ({ onFilterChange, filters = {} }) => {
const formatDate = (date) => date.toISOString().split("T")[0];
const [activeRangeType, setActiveRangeType] = useState(null);

const today = new Date();
const yesterday = new Date(today);
yesterday.setDate(today.getDate() - 1);

const last7Start = new Date(today);
last7Start.setDate(today.getDate() - 6);

const last30Start = new Date(today);
last30Start.setDate(today.getDate() - 29);

const thisMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
const thisMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0);

const prevMonthStart = new Date(today.getFullYear(), today.getMonth() - 1, 1);
const prevMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0);

const openRangeModal = (type) => {
    setActiveRangeType(type);
};

const closeRangeModal = () => {
    setActiveRangeType(null);
};

const handleDateRangeChange = (value) => {
    onFilterChange("dateRange", value);
    if (value === "custom") {
        openRangeModal("plan");
    }
};

const handleWithdrawalRangeChange = (value) => {
    onFilterChange("withdrawalDateRange", value);
    if (value === "custom") {
        openRangeModal("withdrawal");
    }
};

const getCustomLabel = (type) => {
    const start = filters[`${type}StartDate`];
    const end = filters[`${type}EndDate`];
    if (start || end) {
        return `Własne (${start || "..."} → ${end || "..."})`;
    }
    return "Własne";
};

return (
    <Container fluid className="mt-4 w-100">
        <Form>
            <Row className="mb-3 g-3 align-items-end scheduled-filters-row">
                <Col xs={12} sm={6} lg={3} className="scheduled-filters-col">
                    <Form.Group controlId="dateRange">
                        <Form.Label>Data zaplanowania</Form.Label>
                        <Form.Control
                            as="select"
                            value={filters.dateRange || ""}
                            onChange={(e) => handleDateRangeChange(e.target.value)}
                        >
                            <option value="">-- Wybierz --</option>
                            <option value="today">Dzisiaj ({formatDate(today)})</option>
                            <option value="yesterday">Wczoraj ({formatDate(yesterday)})</option>
                            <option value="last7Days">
                                Ostatnie 7 dni ({formatDate(last7Start)} - {formatDate(today)})
                            </option>
                            <option value="previousMonth">
                                Poprzedni miesiąc ({formatDate(prevMonthStart)} - {formatDate(prevMonthEnd)})
                            </option>
                            <option value="thisMonth">
                                Ten miesiąc ({formatDate(thisMonthStart)} - {formatDate(thisMonthEnd)})
                            </option>
                            <option value="last30Days">
                                Ostatnie 30 dni ({formatDate(last30Start)} - {formatDate(today)})
                            </option>
                            <option value="custom">{getCustomLabel("plan")}</option>
                        </Form.Control>
                    </Form.Group>
                </Col>

                <Col xs={12} sm={6} lg={3} className="scheduled-filters-col">
                    <Form.Group controlId="withdrawalDateRange">
                        <Form.Label>Data wycofania</Form.Label>
                        <Form.Control
                            as="select"
                            value={filters.withdrawalDateRange || ""}
                            onChange={(e) => handleWithdrawalRangeChange(e.target.value)}
                        >
                            <option value="">-- Wybierz --</option>
                            <option value="today">Dzisiaj ({formatDate(today)})</option>
                            <option value="yesterday">Wczoraj ({formatDate(yesterday)})</option>
                            <option value="last7Days">
                                Ostatnie 7 dni ({formatDate(last7Start)} - {formatDate(today)})
                            </option>
                            <option value="previousMonth">
                                Poprzedni miesiąc ({formatDate(prevMonthStart)} - {formatDate(prevMonthEnd)})
                            </option>
                            <option value="thisMonth">
                                Ten miesiąc ({formatDate(thisMonthStart)} - {formatDate(thisMonthEnd)})
                            </option>
                            <option value="last30Days">
                                Ostatnie 30 dni ({formatDate(last30Start)} - {formatDate(today)})
                            </option>
                            <option value="custom">{getCustomLabel("withdrawal")}</option>
                        </Form.Control>
                    </Form.Group>
                </Col>

                <Col xs={12} sm={6} lg={2} className="scheduled-filters-col">
                    <Form.Group controlId="terminalDr">
                        <Form.Label>Terminal DR</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder=""
                            value={filters.terminalDr || ""}
                            onChange={(e) => onFilterChange("terminalDr", e.target.value)}
                        />
                    </Form.Group>
                </Col>
                <Col xs={12} sm={6} lg={2} className="scheduled-filters-col">
                    <Form.Group controlId="terminalEx">
                        <Form.Label>Terminal EX</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder=""
                            value={filters.terminalEx || ""}
                            onChange={(e) => onFilterChange("terminalEx", e.target.value)}
                        />
                    </Form.Group>
                </Col>
                <Col xs={12} sm={6} lg={2} className="scheduled-filters-col">
                    <Form.Group controlId="soN">
                        <Form.Label>Status</Form.Label>
                        <Form.Control
                            as="select"
                            value={filters.soN || ""}
                            onChange={(e) => onFilterChange("soN", e.target.value)}
                        >
                            <option value="">-- Wybierz --</option>
                            <option value="Approved">Zaplanowane</option>
                            <option value="Pending">Do akceptacji</option>
                            <option value="Rejected">Odrzucone</option>
                            <option value="Queued">W trakcie wykonywania</option>
                            <option value="Executed">Wykonane</option>
                            <option value="Withdrawn">Wycofane</option>
                        </Form.Control>
                    </Form.Group>
                </Col>
            </Row>
        </Form>

        <Modal show={!!activeRangeType} onHide={closeRangeModal} centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    {activeRangeType === "withdrawal"
                        ? "Zakres dat wycofania"
                        : "Zakres dat zaplanowania"}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row className="g-3">
                    <Col xs={12}>
                        <Form.Group controlId={`${activeRangeType || "plan"}StartDate`}>
                            <Form.Label>Od</Form.Label>
                            <Form.Control
                                type="date"
                                value={
                                    filters[
                                        `${activeRangeType || "plan"}StartDate`
                                    ] || ""
                                }
                                onChange={(e) =>
                                    onFilterChange(
                                        `${activeRangeType || "plan"}StartDate`,
                                        e.target.value
                                    )
                                }
                            />
                        </Form.Group>
                    </Col>
                    <Col xs={12}>
                        <Form.Group controlId={`${activeRangeType || "plan"}EndDate`}>
                            <Form.Label>Do</Form.Label>
                            <Form.Control
                                type="date"
                                value={
                                    filters[
                                        `${activeRangeType || "plan"}EndDate`
                                    ] || ""
                                }
                                onChange={(e) =>
                                    onFilterChange(
                                        `${activeRangeType || "plan"}EndDate`,
                                        e.target.value
                                    )
                                }
                            />
                        </Form.Group>
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={closeRangeModal}>
                    Zamknij
                </Button>
            </Modal.Footer>
        </Modal>
    </Container>
);
};

export default ScheduledChangesFilters;
